import { Program, _Program } from './Program';

export class MylistItem {
  constructor(
    public id: number,
    public userId: number,
    public channelSignatureType: number,
    public priority: number,
    public createdAt: string,
    public updatedAt: string,
    public deletedAt: string | null,
    public bancolle: string | null,
    public futurePrograms: _Program[] | Program[] | null,
    public channel: {
      id: number;
      myBancolleId: number;
      isLike: number;
      isRemind: number;
      title: string;
      episord: string | null;
      onairAt: Date;
      detailUrl: string;
      channelSignatureType: number;
      name: string | null;
      channelSignatureName: string;
      createdAt: string;
      updatedAt: string;
      deletedAt: string | null;
      channelType: 'tch1' | 'tch2';
      remindUserId: number;
      thumbnail: string | null;
      description: string | null;
    }
  ) {}

  public cloneWith = (args: { futurePrograms?: MylistItem['futurePrograms'] }) => {
    return new MylistItem(
      this.id,
      this.userId,
      this.channelSignatureType,
      this.priority,
      this.createdAt,
      this.updatedAt,
      this.deletedAt,
      this.bancolle,
      args.futurePrograms || this.futurePrograms,
      {
        id: this.channel.id,
        myBancolleId: this.channel.myBancolleId,
        isLike: this.channel.isLike,
        isRemind: this.channel.isRemind,
        title: this.channel.title,
        episord: this.channel.episord,
        onairAt: this.channel.onairAt,
        detailUrl: this.channel.detailUrl,
        channelSignatureType: this.channel.channelSignatureType,
        name: this.channel.name,
        channelSignatureName: this.channel.channelSignatureName,
        createdAt: this.channel.createdAt,
        updatedAt: this.channel.updatedAt,
        deletedAt: this.channel.deletedAt,
        channelType: this.channel.channelType,
        remindUserId: this.channel.remindUserId,
        thumbnail: `https://www.tbs.co.jp/tbs-ch/item/${this.channel.channelSignatureName}/thumbs/title-608.jpg`,
        description: this.channel.description,
      }
    );
  };
}

export class MyListItemBuilder {
  private _id: MylistItem['id'] = 0;
  private _userId: MylistItem['userId'] = 0;
  private _channelSignatureType: MylistItem['channelSignatureType'] = 0;
  private _priority: MylistItem['priority'] = 0;
  private _createdAt: MylistItem['createdAt'] = '';
  private _updatedAt: MylistItem['updatedAt'] = '';
  private _deletedAt: MylistItem['deletedAt'] = null;
  private _bancolle: MylistItem['bancolle'] = null;
  private _futurePrograms: MylistItem['futurePrograms'] = [];
  private _channel: MylistItem['channel'] = {
    id: 0,
    myBancolleId: 0,
    isLike: 0,
    isRemind: 0,
    title: '',
    episord: null,
    onairAt: new Date(),
    detailUrl: '',
    channelSignatureType: 2,
    name: null,
    channelSignatureName: '',
    createdAt: '',
    updatedAt: '',
    deletedAt: null,
    channelType: 'tch1',
    remindUserId: 0,
    thumbnail: null,
    description: null,
  };

  public withChannel(channel: MylistItem['channel']) {
    this._channel = channel;
    return this;
  }
  public widthFuturePrograms(futurePrograms: MylistItem['futurePrograms']) {
    this._futurePrograms = futurePrograms;
    return this;
  }

  public widthPriority(priority: MylistItem['priority']) {
    this._priority = priority;
    return this;
  }

  public withId(id: MylistItem['id']) {
    this._id = id;
    return this;
  }

  public build() {
    return new MylistItem(
      this._id,
      this._userId,
      this._channelSignatureType,
      this._priority,
      this._createdAt,
      this._updatedAt,
      this._deletedAt,
      this._bancolle,
      this._futurePrograms,
      this._channel
    );
  }

  public objectBuild() {
    return {
      id: this._id,
      userId: this._userId,
      channelSignatureType: this._channelSignatureType,
      priority: this._priority,
      createdAt: this._createdAt,
      updatedAt: this._updatedAt,
      deletedAt: this._deletedAt,
      bancolle: this._bancolle,
      futurePrograms: this._futurePrograms,
      channel: this._channel,
    };
  }
}
